export default "__VITE_ASSET__a6822b92__"